<template>
  <div class="relative">
    <div
      class="text-center flex justify-center items-center cursor-pointer space-x-2"
      @click="showDropdown = !showDropdown"
    >
      <span
        class="w-8 h-8 rounded-full flex items-center justify-center bg-grey-100"
      >
        <i class="fa fa-user"></i>
      </span>
      <span class="text-sm mr-2 font-semibold hidden md:block" v-if="isPreview"
        >{{ $t('hey') }} {{ user.name.split(' ')[0] }} !</span
      >
      <span v-if="isPreview"><i class="fa fa-angle-down"></i></span>
    </div>
    <div
      v-show="showDropdown"
      class="md:absolute bg-white text-base md:w-48 list-none md:text-left text-center rounded shadow mt-3 z-30"
    >
      <a
        @click="openProfilePopup"
        class="hover:bg-grey-100 text-sm py-3 px-4 font-semibold block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
        {{ profileLabel }}
      </a>
      <a
        v-if="!isPortal"
        @click="logoutUser"
        class="text-sm py-3 hover:bg-grey-100 px-4 font-semibold block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
        {{logoutLabel}}
      </a>
      <a
        v-else
        @click="backPortalPage"
        class="text-sm py-2 hover:bg-grey-100 px-4 font-semibold block w-full whitespace-no-wrap bg-transparent text-gray-800"
      >
        {{ $t('Back to portal') }} 
      </a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Profile',
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    user: {
      type: Object,
      required: true,
    },
    openProfilePopup: {
      type: Function,
      required: true,
    },
    logoutUser: {
      type: Function,
      required: true,
    },
    isPortal: {
      type: Boolean,
      default: false,
    },
    backPortalPage: {
      type: Function,
      default: () => {},
    },
    profileLabel: {
        type: String,
        default: 'Profile',
    },
    logoutLabel: {
        type: String,
        default: 'Logout',
    }
  },
  data() {
    return {
      showDropdown: false,
    };
  },
};
</script>